<script setup lang="ts">
import { useAuthStore } from '@/stores';
import { useConfirm } from 'primevue/useconfirm';
import { watch, computed, nextTick } from 'vue';
const confirm = useConfirm();
const authStore = useAuthStore();
const banModalInfo = computed(() => authStore.banModalInfo);
const toOpenBanModal = async () => {
    try {
        await showBanModal();
        authStore.signOut();
    } catch (error) {
        console.error(error);
    }
};
watch(
    () => banModalInfo.value,
    (newValue) => {
        if (newValue.modal) {
            nextTick(() => {
                toOpenBanModal();
            });
        }
    },
    { immediate: true, deep: true }
);
async function showBanModal() {
    const header = banModalInfo.value.type === 'block_permanent' ? 'account_blocked_forever' : 'account_blocked_temp';
    const message = banModalInfo.value.type === 'block_permanent' ? 'account_blocked_forever_message' : `account_blocked_temp_message`;
    return new Promise((resolve, reject) => {
        confirm.require({
            group: 'banModal',
            header,
            message,
            accept: () => {
                resolve(true);
            },
            reject: () => {
                reject(false);
            }
        });
    });
}
</script>

<template>
    <ConfirmDialog group="banModal" pt:root:class="!rounded-lg">
        <template #container="{ message, acceptCallback }">
            <div class="flex flex-col items-center rounded-lg bg-surface-900 p-8">
                <div class="text-white-500 -mt-20 inline-flex h-24 w-24 items-center justify-center rounded-full bg-red-500">
                    <i class="pi pi-ban !text-5xl text-white"></i>
                </div>
                <h1 class="mb-2 mt-6 block text-3xl font-bold uppercase text-red-500">{{ $t(message.header) }}</h1>
                <div class="flex flex-col items-center gap-2">
                    <p class="mb-0 text-center text-surface-200">{{ $t(message.message) }}</p>
                    <Tag severity="info" v-if="banModalInfo.type === 'block_temporary' && banModalInfo.time">
                        <span>
                            {{ `${$t('until')} ${banModalInfo.time}` }}
                        </span>
                    </Tag>
                </div>
                <div class="mt-6">
                    <Button fluid severity="danger" :label="$t('logout')" @click="acceptCallback" class="px-8 font-semibold uppercase" />
                </div>
            </div>
        </template>
    </ConfirmDialog>
</template>
